import { provideZoneChangeDetection } from "@angular/core";
/// <reference types="@angular/localize" />

import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';
import * as Sentry from "@sentry/angular";
import { environment } from './environments/environment.prod';

import { AppModule } from './app/app.module';
import {
  shouldDropSentryHttpNoiseEvent,
  extractErrorMessage,
  isExtensionAsyncChannelMessage,
  isBenignPdfJsCleanupMessage,
} from './app/http/http-auth-telemetry';
// if (environment.production) {
  // if (window) {
  //   window.console.log = function () { };
  //   window.console.warn = function () { };
  //   window.console.error = function () { };
  // }
// }
//
// window.onbeforeunload = null;
// window.addEventListener('beforeunload', (event) => {
//   event.stopImmediatePropagation();
// }, true);

Sentry.init({
  dsn: environment.sentryDsn,
  enabled: false,
  release: "qrda-webportal@1.0.0",
  // pdf.js / ngx-extended-pdf-viewer: cleanup while a page is still rendering (nuisance).
  ignoreErrors: [
    /startCleanup:\s*Page\s+\d+\s+is currently rendering/i,
    /Uncaught \(in promise\):\s*Error:\s*startCleanup:\s*Page\s+\d+\s+is currently rendering/i,
  ],
  integrations: [
    Sentry.browserTracingIntegration({
      // 🛡️ CRITICAL: Prevent Sentry from touching PDF binary streams
      shouldCreateSpanForRequest: (url) => !url.match(/pdf|blob|worker/i),
    }),
    Sentry.browserProfilingIntegration(),
    Sentry.replayIntegration(),

  ],
  beforeSend(event) {
    if (shouldDropSentryHttpNoiseEvent(event)) {
      return null;
    }
    return event;
  },
  beforeBreadcrumb: (breadcrumb) => {
    const url = breadcrumb.data?.['url'];
    if (typeof url === 'string' && /pdf|blob/i.test(url)) {
      return null;
    }
    return breadcrumb;
  },
  // Performance Monitoring
  tracesSampleRate: 1.0, //  Capture 100% of the transactions
  // Set 'tracePropagationTargets' to control for which URLs distributed tracing should be enabled
  tracePropagationTargets: ["localhost", /^https:\/\/yourserver\.io\/api/],
  // Session Replay
  replaysSessionSampleRate: 0.1, // This sets the sample rate at 10%. You may want to change it to 100% while in development and then sample at a lower rate in production.
  replaysOnErrorSampleRate: 1.0, // If you're not already sampling the entire session, change the sample rate to 100% when sampling sessions where errors occur.
  profilesSampleRate: 0.1,
});

// Browser extensions sometimes reject promises in the page context with this known
// runtime message; ignore only this specific noise to keep app error logs clean.
function swallowBenignUnhandledRejection(event: PromiseRejectionEvent): void {
  const message = extractErrorMessage(event.reason);

  if (
    isExtensionAsyncChannelMessage(message) ||
    isBenignPdfJsCleanupMessage(message) ||
    /transport destroyed/i.test(message) ||
    (typeof event.reason === 'object' &&
      event.reason !== null &&
      'status' in event.reason &&
      (event.reason as { status?: number }).status === 0) ||
    /Http failure response for .+?:\s*0(?:\s+Unknown Error)?/i.test(message) ||
    (/assets\/json\/translations-/i.test(message) && /Unknown Error/i.test(message))
  ) {
    event.preventDefault();
    event.stopImmediatePropagation();
  }
}

window.addEventListener('unhandledrejection', swallowBenignUnhandledRejection, true);

platformBrowserDynamic().bootstrapModule(AppModule, { applicationProviders: [provideZoneChangeDetection()], }).then(ref => {
  // Ensure Angular destroys itself on hot reloads.
  if ((window as { [key: string]: any })['ngRef']) {
    (window as { [key: string]: any })['ngRef'].destroy();
  }
  (window as { [key: string]: any })['ngRef'] = ref;

  

  // Otherwise, log the boot error
}).catch(err => console.error(err));
